import { K as s } from "./export-cdcbfb2b.js";
var e = { exports: {} };
(function(t) {
  function o(r) {
    if (r == null)
      throw new TypeError("Cannot destructure " + r);
  }
  t.exports = o, t.exports.__esModule = !0, t.exports.default = t.exports;
})(e);
var p = e.exports;
const n = /* @__PURE__ */ s(p);
export {
  n as _
};
